<app-repeat-filter (generated)="generated($event)" [isCreating]="isCreating" [selectedDay]="selectedDay" [startDate]="startDate"
  [startTime]="startTime"></app-repeat-filter>
<app-repeat-calendar *ngIf="isDateGenerated" [isCreating]="isCreating"
  (checkConflictApi)="checkConflict($event)" (retryFailedDates)="retryFailedDates.emit($event)"></app-repeat-calendar>
